import Checkbox from './Checkbox'
import { forwardRef } from 'react'
import { preventDefault } from '../../utils'
import type { CheckboxProps } from './types'

const ClientCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(function ClientCheckbox(
  { onChange: onChange_, onClick: onClick_, ...props },
  ref
) {
  const { disabled } = props
  const onChange = disabled ? preventDefault : onChange_
  const onClick = disabled ? preventDefault : onClick_
  return <Checkbox {...props} onChange={onChange} onClick={onClick} ref={ref} />
})

export default ClientCheckbox
